var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "nonzero",
    d: "M19 3c1.657 0 3 1.343 3 3v12c0 1.657-1.343 3-3 3h-5c-1.657 0-3-1.343-3-3v-2c0-.552.448-1 1-1s1 .448 1 1v2c0 .552.448 1 1 1h5c.552 0 1-.448 1-1V6c0-.552-.448-1-1-1h-5c-.552 0-1 .448-1 1v2c0 .552-.448 1-1 1s-1-.448-1-1V6c0-1.657 1.343-3 3-3h5zM2 11.977l.001-.03.002-.029.01-.079c0-.01.003-.02.004-.032.013-.07.033-.138.06-.203l.007-.02c.035-.08.074-.146.119-.207l.017-.023c.019-.023.038-.046.058-.067l.013-.014L7.038 6.3c.388-.401 1.017-.401 1.405 0 .388.402.388 1.053 0 1.455L5.378 10.97h11.628c.55 0 .994.46.994 1.029 0 .568-.445 1.029-.994 1.029l-11.628-.001 3.065 3.216c.388.402.388 1.053 0 1.455-.388.401-1.017.401-1.405 0L2.29 12.727l-.064-.073-.024-.031c-.046-.062-.085-.13-.116-.202l-.01-.025c-.027-.065-.047-.133-.06-.203l-.005-.032c-.004-.025-.007-.05-.009-.077L2 12.023v-.046z",
    transform: "translate(-328 -610) translate(40 609) translate(288 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-328 -610) translate(40 609) translate(288 1)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.8722d87b.svg";
export { ForwardRef as ReactComponent };